import React from 'react';
import styles from './styles.module.scss';

const HorizontalForm: React.FunctionComponent = ({ children }) => (
  <div className={styles.horizontalFormWrapper}>
    {React.Children.map(children, (child) =>
      child ? <div className={styles.horizontalFormItem}>{child}</div> : null,
    )}
  </div>
);

export default HorizontalForm;
